import { Check, Copy } from "lucide-react";
import * as React from "react";
import {
  Button,
  type ButtonProps,
  type DistributiveOmit,
} from "@/components/ui/button";
import { useAnnounce } from "@/hooks/use-announcer";

type CopyToClipboardButtonProps = DistributiveOmit<ButtonProps, "onClick"> & {
  value: string;
  label?: string;
};

export function CopyToClipboardButton({
  value,
  label,
  ...props
}: CopyToClipboardButtonProps) {
  const [copied, setCopied] = React.useState(false);
  const announce = useAnnounce();
  const isIcon = props.size === "icon";

  const handleClick = async () => {
    // [sp] this is only available on localhost or https
    if (navigator.clipboard == null) {
      console.log("Would have copied:", value);
    } else {
      await navigator.clipboard.writeText(value);
    }
    setCopied(true);
    announce("Copied to clipboard.");
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Button {...props} onClick={handleClick}>
      {copied ? (
        <>
          <Check className="h-4 w-4 text-success-text" />
          {!isIcon && (label ? " Copied!" : " Copied!")}
        </>
      ) : (
        <>
          <Copy className="h-4 w-4" />
          {!isIcon && label && ` ${label}`}
        </>
      )}
    </Button>
  );
}
